import { createFileRoute } from '@tanstack/react-router';
import { loadShire, makeShireSubPageHead, type ShireLoaderData } from '../components/shared/shire-sub-route';
import { ShireSubPageShell } from '../components/shared/ShireSubPageShell';
import { ShireTransportSection } from '../components/shared/ShireTransportSection';
import { ShireMainRoadsSection } from '../components/shared/ShireMainRoadsSection';

export const Route = createFileRoute('/shire/$name_/transport')({
  loader: ({ params }) => loadShire(params.name),
  head: (ctx) =>
    makeShireSubPageHead(
      (ctx as { loaderData?: ShireLoaderData } | undefined)?.loaderData,
      'Transport',
      'Transwa services, state roads, heavy vehicles and getting around this shire.',
    ),
  component: TransportPage,
});

function TransportPage() {
  const { shire } = Route.useLoaderData() as ShireLoaderData;
  return (
    <ShireSubPageShell
      shire={shire}
      eyebrow="Transport"
      title="Getting around"
      lede={`Transwa coach and rail services, state roads and heavy-vehicle information for the Shire of ${shire.name}.`}
    >
      <ShireTransportSection shireId={shire.id} />
      <ShireMainRoadsSection shireId={shire.id} />
    </ShireSubPageShell>
  );
}
